import { Gate } from '@streamr/utils';
import { PushBuffer } from './../utils/PushBuffer';
class MsgChainProcessor {
    busy = new Gate(true);
    inputBuffer = [];
    outputBuffer;
    processMessageFn;
    onError;
    constructor(outputBuffer, processMessageFn, onError) {
        this.outputBuffer = outputBuffer;
        this.processMessageFn = processMessageFn;
        this.onError = onError;
    }
    async addMessage(message) {
        this.inputBuffer.push(message);
        if (this.busy.isOpen()) {
            this.busy.close();
            while (this.inputBuffer.length > 0) {
                const nextMessage = this.inputBuffer.shift();
                try {
                    const processedMessage = await this.processMessageFn(nextMessage);
                    this.outputBuffer.push(processedMessage);
                }
                catch (e) {
                    this.onError.trigger(e);
                }
            }
            this.busy.open();
        }
    }
}
export class MsgChainUtil {
    outputBuffer = new PushBuffer();
    processors = new Map();
    processMessageFn;
    onError;
    constructor(processMessageFn, onError) {
        this.processMessageFn = processMessageFn;
        this.onError = onError;
    }
    addMessage(message) {
        const id = `${message.getPublisherId()}-${message.getMsgChainId()}`;
        let processor = this.processors.get(id);
        if (processor === undefined) {
            processor = new MsgChainProcessor(this.outputBuffer, this.processMessageFn, this.onError);
            this.processors.set(id, processor);
        }
        processor.addMessage(message); // add a task, but don't wait for it to complete
    }
    async flush() {
        await Promise.all(Array.from(this.processors.values()).map((p) => p.busy.waitUntilOpen()));
    }
    stop(err) {
        this.outputBuffer.endWrite(err);
    }
    [Symbol.asyncIterator]() {
        return this.outputBuffer;
    }
}
